import { Body2 } from '@cian/ui-kit';

import { type FC } from 'react';

import { TransportIcon, type TransportTypes } from 'shared/components/TransportIcon';

import styles from './Transport.css';

export type TransportProps = {
  name: string;
  iconColor: string | null | undefined;
  remoteness: string | null | undefined;
  iconType: TransportTypes | null | undefined;
};

export const Transport: FC<TransportProps> = props => {
  const { iconColor, name, remoteness, iconType } = props;

  return (
    <div className={styles['container']} data-testid="metro_block">
      {!!iconColor && !!iconType && (
        <div className={styles['icon']}>
          <TransportIcon iconColor={iconColor} iconType={iconType} />
        </div>
      )}
      <Body2 display="inline">{name}</Body2>
      <span className={styles['remoteness']}>
        <Body2 color="text-secondary-default" display="inline">
          {remoteness}
        </Body2>
      </span>
    </div>
  );
};
